import { MultiplySection } from '@/components/dashboard/MultiplySection'

export function MultiplyPage() {
  return (
    <div style={{ maxWidth: 1280, margin: '0 auto', padding: '24px' }}>
      <MultiplySection />
    </div>
  )
}
